export default {
  "TimelineCards": "_TimelineCards_7gayy_1",
  "TimelineBlock": "_TimelineBlock_7gayy_7"
};import "ni:sha-256;n_D1-cLkFvHRl838CZ6EY0-Ou2zkEW07WHgYL1tIcCQ";